@if (alerts().length || clockWidget.enabled()) {
<div class="alerts-marquee" [class.paused]="paused() || tabHidden()">
  <ng-content select="app-usa-timezone-clock" />

  <div class="alerts-marquee-viewport">
    <div class="alerts-marquee-track" [style.animationDuration]="scrollDuration()">
      @for (group of [0, 1]; track group) {
      <div #marqueeGroup class="alerts-marquee-group" [attr.aria-hidden]="group === 1 ? 'true' : null">
        @for (alert of alerts(); track alert.id) {
        <app-alerts-marquee-item [alert]="alert" [decorative]="group === 1" (openEntity)="handleOpenEntity($event)" />
        }
      </div>
      }
    </div>
  </div>

  @if (alerts().length) {
  <div class="alerts-marquee-controls">
    <div class="alerts-status-stack">
      <span class="alerts-count">
        <span class="alerts-live-dot" aria-hidden="true"></span>
        {{ totalCount() || alerts().length }} High alerts
      </span>
      @if (lastRefreshedLabel()) {
      <span class="alerts-synced">updated {{ lastRefreshedLabel() }}</span>
      }
    </div>
    <div class="alerts-marquee-actions">
      <app-button icon="refresh" [iconOnly]="true" variant="ghost" tone="neutral" size="xs" iconWidth="13px"
        iconHeight="13px" iconFill="currentColor" [extraClass]="loading() ? 'alerts-refreshing' : ''"
        [disabled]="loading()" ariaLabel="Refresh alerts" (btnOnClick)="refresh()" />
      <app-button [icon]="paused() ? 'right' : 'pause'" [iconOnly]="true" variant="ghost" tone="neutral" size="xs"
        iconWidth="13px" iconHeight="13px" iconFill="currentColor"
        [ariaLabel]="paused() ? 'Resume alerts' : 'Pause alerts'" (btnOnClick)="togglePause()" />
    </div>
  </div>
  }
</div>
}

@defer (when assetPopup()) {
@if (assetPopup(); as ap) {
<app-popup [trigger]="true" [heading]="ap.heading" size="xl" exclusiveGroup="asset-detail" (handleClose)="closeAssetPopup()">
  @switch (ap.entity) {
  @case ('trailer') {
  <app-trailer-compact-detail [trailer]="ap.data" />
  }
  @case ('truck') {
  <app-truck-compact-detail [truck]="ap.data" />
  }
  @case ('driver') {
  <app-driver-compact-detail [driver]="ap.data" />
  }
  }
</app-popup>
}
}

@if (loadPopup(); as lp) {
<app-popup [trigger]="true" [heading]="lp.heading" size="xl" exclusiveGroup="asset-detail"
  [popupStyle]="{ minHeight: 'calc(90vh / var(--app-zoom, 1))' }" (handleClose)="closeLoadPopup()">
  @if (loadDetailsComp(); as comp) {
  <ng-container
    *ngComponentOutlet="comp; injector: loadDetailsInjector(); inputs: { loadIdInput: lp.loadId, from: 'load-list', reload: false }" />
  }
</app-popup>
}

@if (dispatchPopup(); as dp) {
<app-popup [trigger]="true" [heading]="dp.heading" size="xl" exclusiveGroup="asset-detail"
  [popupStyle]="{ minHeight: 'calc(90vh / var(--app-zoom, 1))' }" (handleClose)="closeDispatchPopup()">
  @if (dispatchDetailsComp(); as comp) {
  <ng-container *ngComponentOutlet="comp; injector: dispatchDetailsInjector(); inputs: { dispatchId: dp.dispatchId }" />
  }
</app-popup>
}
